













import Vue, {PropType} from 'vue';
export default Vue.extend({
    props: {
        images: {
            type: Array as PropType<string[]>,
            required: true
        }
    },
    data(): {
        currentIndex: number
    } {
      return {
          currentIndex: 0,
      }
    },
    computed: {
        currentImage() { return this.images[this.$data.currentIndex] }
    },
    methods: {
        changeImage(index: number): void {
            this.$data.currentIndex = index;
        }
    }
});
